// extracted by mini-css-extract-plugin
export default {"notpage":"NotFoundPage_notpage__eRRMF","title":"NotFoundPage_title__4G8FX","back":"NotFoundPage_back__BivMQ"};